<template>
  <div>
    <ChangePassword v-bind:source="2" v-bind:eml="getEmail()"/>
  </div>
</template>

<script>
import ChangePassword from '../../components/misc/ChangePassword.vue'

  export default {
    data () {
      return {
      }
    },
    components: {
      ChangePassword
    },
    methods: {
      getEmail() {
        return this.$store.getters.user.email
      }
    }

  }
</script>


<style>

</style>
